'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cancel = require('./Cancel');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cancel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Cancel/index.js
// module id = 1132
// module chunks = 1